/**
 * Activity 1 Plant Entry Form — JS-injected submit buttons.
 * Same pattern as _activity-1-form.js.
 */
module.exports = function init_activity1_plant($) {

  if (!window.acf) return;

  acf.addAction('ready', function () {

    const $form = $('.af-form');
    if (!$form.length) return;

    const plant = (typeof mlmp_settings !== 'undefined') ? (mlmp_settings.a1_plant || {}) : {};

    // Replace {monitoring_date} token — operates on bare text nodes only
    // so sibling elements (instructions, etc.) are left untouched.
    if (plant.monitoring_date) {
      $form.find('*').contents().filter(function () {
        return this.nodeType === 3 && this.nodeValue.indexOf('{monitoring_date}') !== -1;
      }).each(function () {
        this.nodeValue = this.nodeValue.replace('{monitoring_date}', plant.monitoring_date);
      });
    }
    const $intent = $form.find('.acf-field[data-name="submission_intent"] input');
    const $native = $form.find('[type="submit"]');

    $native.hide();

    function set_intent_and_submit(intent) {
      $intent.val(intent).trigger('change');
      $native.trigger('click');
    }

    const $btn_wrap = $('<div>', { class: 'form-actions a1-plant-form-actions' }).insertAfter($form);

    $('<button>', { type: 'button', class: 'mlmp-button-small', text: plant.btn_save_add || 'Save and add another plant' })
      .on('click', function () { set_intent_and_submit('save_add'); })
      .appendTo($btn_wrap);

    $('<button>', { type: 'button', class: 'mlmp-button-small', text: plant.btn_save_done || 'Save and done' })
      .on('click', function () { set_intent_and_submit('save_done'); })
      .appendTo($btn_wrap);

    const cancel_url = plant.cancel_url || '#';
    $('<a>', { href: cancel_url, class: 'mlmp-button-small', text: plant.btn_cancel || 'Cancel' })
      .appendTo($btn_wrap);

  });

};
